import { CalendarCheck, Check, PhoneMissed, Star } from "lucide-react";
import { cn } from "@/lib/utils";
import { Reveal } from "@/components/motion/Reveal";
import { CTAButton } from "@/components/site/CTAButton";

const ICONS = { PhoneMissed, Star, CalendarCheck };

export const PlanCard = ({ plan, kind, index = 0 }) => {
  const Icon = plan.icon ? ICONS[plan.icon] : null;
  return (
    <Reveal
      delay={index * 0.08}
      data-testid={`plan-card-${plan.id}`}
      className={cn(
        "relative flex flex-col rounded-2xl border p-6 sm:p-8",
        plan.popular
          ? "border-[#2F6BFF]/60 bg-[#0F1422] shadow-[0_0_0_1px_rgba(47,107,255,0.25),0_40px_90px_-40px_rgba(47,107,255,0.6)]"
          : "border-white/[0.08] bg-[#0E1015]",
      )}
    >
      {plan.popular && (
        <span className="absolute -top-3 left-6 rounded-full bg-[#2F6BFF] px-3 py-1 text-xs font-medium" data-testid="most-popular-badge">
          Most popular
        </span>
      )}
      <div className="flex items-center justify-between">
        <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#A1A1AA]">{kind}</p>
        {Icon && <Icon className="h-5 w-5 text-[#2F6BFF]" aria-hidden="true" />}
      </div>
      <h3 className="mt-3 text-2xl font-semibold tracking-[-0.03em]">{plan.name}</h3>
      <p className="mt-3 text-[15px] leading-relaxed text-[#A1A1AA]">{plan.blurb}</p>
      <div className="mt-6 rounded-xl border border-white/[0.07] bg-white/[0.02] p-4">
        <p className="text-sm text-white/85">Fixed price, quoted up front</p>
        <CTAButton
          to={`/contact?topic=${encodeURIComponent(plan.quoteTopic)}`}
          variant={plan.popular ? "primary" : "secondary"}
          className="mt-3 w-full"
          testId={`request-quote-${plan.id}`}
        >
          Request a quote
        </CTAButton>
      </div>
      <ul className="mt-6 space-y-3">
        {plan.features.map((f) => (
          <li key={f} className="flex gap-3 text-[15px] text-white/85">
            <Check className="mt-0.5 h-4 w-4 shrink-0 text-[#2DD4D4]" aria-hidden="true" />
            {f}
          </li>
        ))}
      </ul>
    </Reveal>
  );
};
